import getKey from '@/clir/utils/getKey';

export const profils = async ({ to, from, next, store }) => {
    if (store.getters['error/isError']) return next();

    const profils = getKey(to, 'meta.middleware.profils');
    if (!store.getters['user/isAuthorised'](profils)) {
        await store.dispatch('error/unAuthorised', { path: from.path || '/login' });
    }
    return next();
};

export default { profils };